import Vue from "vue";
import App from "./App.vue";
import DiamondForm from "./components/DiamondForm.vue";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);

Vue.component("diamond-form", DiamondForm);

new Vue({
  el: "#app",
  render: h => h(App)
});
